import AppSettings from "../../../../Settings/AppSettings";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../Context/AppContext";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import LoadingSuccessErrorAlert from "../../Rules/Components/LoadingSuccessErrorAlert";
import { toast } from "Components/DesignSystem/Toast/useToast";
import PdwUploadDropzone from "./PdwUploadDropzone";

/**
 * PDW "Validate" — a dry run that reports what a file WOULD do, and the CBM
 * file-validation step in the Rules matrix. On the design system since § 126: markup
 * only, handlers untouched.
 *
 * Alone among the three uploaders this one auto-closes, via a `useEffect` with a
 * real `clearTimeout` cleanup — the single poll/timer in this module that does not
 * outlive its component.
 */
const Validate = ({ modalValidateClose, type = null, ruleId=null, compatibilityLevel= '', fetchData, instanceId = "pdw-validate" }) => {
  const appData = useContext(AppContext);
  const channelKey = appData?.channelKey;
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [Loading, setLoading] = useState({status: "", message: "", });
  const [downloadUrl, setDownloadUrl] = useState(null);
  let [selectedFile, setSelectedFile] = React.useState(null);

 async function handle_file_selection(event) {
    event.preventDefault();
    const file = event.target.files[0];
    const totalCount = await appData.checkSelectedFile(file,file.type);
    if (totalCount > 0) {
      setSelectedFile(file); 
    } else{ 
      setSelectedFile(null); 
    }
  }

  // delete selected file
  async function handleFileDelete(event) {
    event.preventDefault();
    if(selectedFile != null) setSelectedFile(null)
  }

  async function do_upload_pdw() {
    setLoading({
      status: "Loading",
      message: "File uploading....",
    });
    const formData = new FormData();
    formData.append("file", selectedFile);
    const url = type === "CBM" ? `rule/validate_file/${ruleId}?compat_level=${compatibilityLevel}` :`pdw/upload/validateproducts/${channelKey}`
    const res = await ServiceWrapper.doPost(
      api_base_url + url,
      formData,
      null,
      AuthManager.getGmsToken(),
      true
    );

    if (!res.errorfound) {
      if (res.data.done) {
        setLoading({
          status: "Loading",
          message: res.data.message,
        });
        setTimeout(() => {
          checkUploadStatus(type === "CBM" ? res?.data?.job_id : res.data.jobid);
        }, 2000);
      } else {
        toast.error(res.data.message);
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      toast.error("Error in updating");
      setLoading({
        status: "Error",
        message: "Error Updating ",
      });
    }
    functionThatResetsTheFileInput();
    setSelectedFile(null);
  }

  const checkUploadStatus = async (jobId) => {
    try {
        if (!jobId) {
            toast.error("Job Id not found");
            setLoading({ status: "Error", message: "JobId not found" });
            return;
        }

        const jobStatusResponse = await ServiceWrapper.doGet(api_base_url + "job/status/" + jobId, null, null, AuthManager.getGmsToken());

        if (jobStatusResponse.errorfound) return;

        if (jobStatusResponse.data.processing) {
            setLoading({ status: "Loading", message: jobStatusResponse.data.status });
            setTimeout(() => { checkUploadStatus(jobId); }, 2000);
            return;
        }

        if (jobStatusResponse.data.error) {
            toast.error(jobStatusResponse.data.status);
            setLoading({ status: "Error", message: jobStatusResponse.data.status });
            return;
        }
        setLoading({ status: "", message: '' });

        const toastMessage = type === "CBM" ? jobStatusResponse?.data?.message : jobStatusResponse?.data?.status;
        const downloadUrl = type === "CBM" ? jobStatusResponse?.data?.data : jobStatusResponse?.data?.data?.url;

        toast.success(toastMessage);
        setDownloadUrl(downloadUrl);

    } catch (error) {
        console.error("checkUploadStatus ~ error:", error);
    }
  };

  useEffect(() => {
    if (downloadUrl) {
      const timer = setTimeout(() => {
        setDownloadUrl(undefined);
        modalValidateClose();
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [downloadUrl]);

  

  const [inputKey, setInputKey] = useState("");
  const functionThatResetsTheFileInput = () => {
    let randomString = Math.random().toString(36);
    setInputKey(randomString);
  };
  return (
    <div>
      <PdwUploadDropzone
        inputId={`${instanceId}-file`}
        inputTestId="upload-validate-input-1"
        inputKey={inputKey}
        onFileSelect={(event) => handle_file_selection(event)}
        selectedFile={selectedFile}
        onDelete={handleFileDelete}
        onCancel={() => modalValidateClose()}
        onSave={() => do_upload_pdw()}
        cancelTestId="pdw-validate-cancel-btn"
        /* Validate had no Save testid either — added, same as Update's. */
        saveTestId="pdw-validate-save-btn"
        deleteTestId="pdw-validate-delete-btn"
        saveDisabled={!selectedFile}
      />

      <div className="tw-mt-4">
        <LoadingSuccessErrorAlert loading={Loading} hide_error={true}/>
      </div>

      {/* Scoped id — `iframe_pdw_download` was hardcoded in four components. */}
      <iframe
        style={{ display: "none" }}
        src={downloadUrl}
        id={`${instanceId}-iframe`}
        title="Validate PDW"
      />
    </div>
  );
};
export default Validate;